import ProgressBar from 'components/ProgressBar'
import NotificationBar from 'components/Notification/NotificationBar'
import {closeModal} from 'actions/subscriptionExpired'
import BillingReminderVersionTwo from 'components/BillingReminderVersionTwo'
import BillingReminder from 'components/BillingReminder'
import addIdentify from 'mixpanel/identify'
import _ from 'lodash'
import Sidebar from 'components/Sidebar'
import moment from 'moment'
import {isFullSiteMode} from 'utils/fullSite'

class LayoutLoggedIn extends React.Component {
  componentDidMount () {
    const {loggedIn, user} = this.props.data.moka
    if (loggedIn) {
      addIdentify(user.id)
    }
  }
  render () {
    let {data, history, dispatch, location, routes, children} = this.props
    let {pathname} = location
    let {moka, notification, subscriptionExpired} = data
    let {user, showLoadingSpinner, permissions} = moka
    let hideHeader = routes[1].hideHeader
    let subMenuOf = _.groupBy(permissions, (permission) => permission.menu.toLowerCase())
    let showBillingReminderClass = this.showBillingReminder(user, subscriptionExpired) ? 'show-billing-reminder' : ''

    return (
      <div>
        {this.showBillingReminder(user, subscriptionExpired) &&
          <div className='visible-md visible-lg'>
            <BillingReminderVersionTwo user={moka.user} subscriptionExpired={subscriptionExpired} />
          </div>}
        <div className='clear' />
        <div id='wrapper' className={`toggled ${showBillingReminderClass}`}>
          {showLoadingSpinner
            ? <div id='loading-container' className='mk-loading-container'>
              <div className='center-spinner moka-spinner' />
            </div>
          : <ProgressBar updateTime={500} currentPath={pathname} />}

          <Sidebar
            data={data}
            history={history}
            dispatch={dispatch}
            location={location}
            routes={routes}
            children={children}
            subMenuOf={subMenuOf}
            user={user}
          />

          <div id='page-content-wrapper' className={`wrapper${this._getFullClassByPath()}`}>
            <div className='container content-sidebar'>
              <div className='row'>
                <div className='col-md-10 col-md-offset-2 fixed-content-sidebar'>
                  <NotificationBar dispatch={dispatch} notification={notification} location={location} sidebarNotification />
                  <div className='col-md-12 app-container'>
                    <div className={`full-height section-content ${hideHeader ? ' no-header' : ''} ${this._getClassByPath()}`}>
                      {!pathname.startsWith('/dashboard') &&
                      <div className='visible-sm visible-xs reminder-responsive'>
                        <BillingReminder user={user} subscriptionExpired={subscriptionExpired} />
                      </div>}
                      <div className='container-full-nosub box-content-container'>
                        {children}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  _getClassByPath () {
    let {location} = this.props
    let classbyPath = location.pathname.split('/')
    if (location.pathname.startsWith('/feedback')) {
      return 'feedback'
    }
    if (classbyPath[1] === 'reset-password') {
      return 'reset-password'
    }
    if (location.pathname.startsWith('/table-management/map') && isFullSiteMode()) {
      return 'map-full-site'
    }
    return classbyPath[classbyPath.length - 1]
  }

  _getFullClassByPath () {
    let {location} = this.props
    let classbyPath = location.pathname.split('/')
    return classbyPath.join('-')
  }

  _hideExpiredModal = () => {
    this.props.dispatch(closeModal())
  }

  _toLinks = (subMenus) => {
    let isMobile = window.innerWidth <= 768
    let links = []
    let sortedSubMenu = _.orderBy(subMenus, 'priority_rank')
    for (let i = 0; i < sortedSubMenu.length; i++) {
      const subMenu = sortedSubMenu[i]
      if (isMobile && !subMenu.mobile_supported) {
        continue
      }
      links.push({
        href: subMenu.urls[0],
        label: subMenu.sub_menu
      })
    }

    return links
  }

  showBillingReminder = (user, subscriptionExpired) => {
    let daysLeft = this.calculateDaysLeft(user)
    let reminder = false

    if (this.isExpired(user, subscriptionExpired)) {
      reminder = true
    } else {
      if (this.isTrial(user) && !this.isAlreadySubscribed(user)) {
        reminder = true
      } else if (!this.isTrial(user) && daysLeft <= 14) {
        reminder = true
      }
    }
    return reminder
  }

  isExpired = (user, subscriptionExpired) => {
    let expired = this.calculateDaysLeft(user) <= 0

    if (expired) {
      subscriptionExpired.expired = true
    }

    return expired
  }

  calculateDaysLeft = (user) => {
    let calculatedDaysLeft = Math.ceil((moment(user.business.expired_at).diff(moment(), 'hours')) / 24)
    let currentDaysInMonth = moment().daysInMonth()
    let daysLeft = 0
    if (calculatedDaysLeft > currentDaysInMonth) {
      daysLeft = currentDaysInMonth
    } else {
      daysLeft = calculatedDaysLeft
    }
    return daysLeft
  }

  isTrial = (user) => {
    return user.business.is_trial
  }

  isAlreadySubscribed = (user) => {
    return user.already_subscribed
  }
}

export default LayoutLoggedIn



// WEBPACK FOOTER //
// ./app/components/Layout/LayoutLoggedIn/LayoutLoggedIn.js